module.exports = __webpack_public_path__ + "static/media/sam-lat-tam-mat-ong.d3780bcf.jpg";